<template lang="pug">
select.form-select(v-model="model")
  option
  option(v-for="bank in banks" :value="smallMode ? bank.code : bank.label") {{ bank.code }} - {{ bank.label }}
</template>

<script>
const banks = [
  { code: '001', label: 'Banco do Brasil' },
  { code: '033', label: 'Santander' },
  { code: '104', label: 'Caixa Econômica' },
  { code: '237', label: 'Bradesco' },
  { code: '237', label: 'Next' },
  { code: '341', label: 'Itaú' },
  { code: '041', label: 'Banrisul' },
  { code: '748', label: 'Sicredi' },
  { code: '756', label: 'Sicoob' },
  { code: '077', label: 'Inter' },
  { code: '070', label: 'BRB' },
  { code: '085', label: 'Via Credi' },
  { code: '655', label: 'Neon/Votorantim' },
  { code: '260', label: 'Nubank' },
  { code: '290', label: 'Pagseguro' },
  { code: '212', label: 'Banco Original' },
  { code: '422', label: 'Safra' },
  { code: '746', label: 'Modal' },
  { code: '021', label: 'Banestes' },
  { code: '136', label: 'Unicred' },
  { code: '274', label: 'Money Plus' },
  { code: '389', label: 'Mercantil do Brasil' },
  { code: '376', label: 'JP Morgan' },
  { code: '364', label: 'Gerencianet Pagamentos do Brasil' },
  { code: '336', label: 'Banco C6' },
  { code: '218', label: 'BS2' },
  { code: '082', label: 'Banco Topazio' },
  { code: '099', label: 'Uniprime' },
  { code: '197', label: 'Stone' },
  { code: '707', label: 'Banco Daycoval' },
  { code: '633', label: 'Rendimento' },
  { code: '004', label: 'Banco do Nordeste' },
  { code: '745', label: 'Citibank' },
  { code: '301', label: 'PJBank' },
  { code: '97', label: 'Cooperativa Central de Credito Noroeste Brasileiro' },
  { code: '084', label: 'Uniprime Norte do Paraná' },
  { code: '384', label: 'Global SCM' },
  { code: '403', label: 'Cora' },
  { code: '323', label: 'Mercado Pago' },
  { code: '003', label: 'Banco da Amazonia' },
  { code: '752', label: 'BNP Paribas Brasil' },
  { code: '383', label: 'Juno' },
  { code: '133', label: 'Cresol' },
  { code: '173', label: 'BRL Trust DTVM' },
  { code: '047', label: 'Banco Banese' },
  { code: '208', label: 'Banco BTG Pactual' },
  { code: '613', label: 'Banco Omni' },
  { code: '332', label: 'Acesso Soluções de Pagamento' },
  { code: '273', label: 'CCR de São Miguel do Oeste' },
  { code: '093', label: 'Polocred' },
  { code: '355', label: 'Ótimo' },
  { code: '121', label: 'Agibank' },
  { code: '037', label: 'Banpará' },
  { code: '380', label: 'Picpay' },
  { code: '125', label: 'Banco Genial' },
  { code: '412-x', label: 'Banco Capital S.A' },
  { code: '741', label: 'Banco Ribeirão Preto' },
  { code: '461', label: 'ASAAS IP' },
  { code: '623', label: 'Banco Pan' },
  { code: '735', label: 'Neon' },
  { code: '310', label: 'VORTX DTVM LTDA' },
  { code: '318', label: 'Banco BMG' },
  { code: '450', label: 'Fitbank' },
  { code: '174', label: 'Pefisa' },
  { code: '451', label: 'J17 - SCD S/A' },
  { code: '089', label: 'Credisan' },
  { code: '529', label: 'Pinbank' },
  { code: '102', label: 'XP Investimentos' },
  { code: '069', label: 'Crefisa' },
  { code: '363', label: 'Singulare' },
]

export default {
  props: {
    value: { type: String },
    inputClass: { type: String },
    smallMode: { type: Boolean, default: false },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    banks() {
      return banks.sort((a, b) => (a.label < b.label ? -1 : 1))
    },
  },
  methods: {
    hasSelected(bank) {
      if (this.smallMode) return this.model === bank.code
      return this.model === bank.label
    },
    checkBank() {
      if (!this.banks.includes(this.model)) this.$emit('input', '')
    },
  },
}
</script>
